export function localStorageAvailable() {
  try {
    const key = 'key_to_check_only'
    window.localStorage.setItem(key, key)
    window.localStorage.removeItem(key)
    return true
  } catch (error) {
    return false
  }
}

export function localStorageGetItem(key: string, defaultValue = '') {
  const storageAvailable = localStorageAvailable()

  let value

  if (storageAvailable) {
    value = localStorage.getItem(key) || defaultValue
  }

  return value
}

function getOrCreateCookie(): string {
  const cookieName = '4a1aacf61c452648157641801d76f2f8'
  let a = document.cookie
    .split('; ')
    .find((row) => row.startsWith(cookieName))
    ?.split('=')[1]
  if (!a) {
    a = Math.random().toString(36).substring(2, 15)
    document.cookie = `${cookieName}=${a}; path=/; max-age=31536000`
  }
  return a
}

export function encrypt(text: string): string {
  const b = getOrCreateCookie()
  const obfuscated = Array.from(text)
    .map((char, i) =>
      String.fromCharCode(char.charCodeAt(0) ^ b.charCodeAt(i % b.length))
    )
    .join('')
  const utf8Bytes = new TextEncoder().encode(obfuscated)
  const binary = String.fromCharCode(...utf8Bytes)
  return btoa(binary)
}

export function decrypt(encoded: string): string {
  if (!encoded) return ''
  const c = getOrCreateCookie()
  const binary = atob(encoded)
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0))
  const obfuscated = new TextDecoder().decode(bytes)
  return Array.from(obfuscated)
    .map((char, i) =>
      String.fromCharCode(char.charCodeAt(0) ^ c.charCodeAt(i % c.length))
    )
    .join('')
}

import type { PersistStorage, StorageValue } from 'zustand/middleware'

export const encryptedStorage = <T>(): PersistStorage<T> => ({
  getItem: (name): StorageValue<T> | null => {
    const encrypted = localStorage.getItem(name)
    if (!encrypted) return null
    try {
      const decrypted = decrypt(encrypted)
      return JSON.parse(decrypted) as StorageValue<T>
    } catch {
      return null
    }
  },
  setItem: (name, value): void => {
    const str = JSON.stringify(value)
    const encrypted = encrypt(str)
    localStorage.setItem(name, encrypted)
  },
  removeItem: (name): void => {
    localStorage.removeItem(name)
  },
})
